const sliderCaseStudyInit = (block) => {
    const sliders = block
        ? [block[0].querySelector('.bn-slider-case-study .bn-slider-case-study__swiper')]
        : Array.from(document.querySelectorAll('.bn-slider-case-study .bn-slider-case-study__swiper'));

    if (sliders) {
        sliders.forEach((slider) => {
            if (slider) {
                const wrapper = slider.closest('.bn-slider-case-study');
                const slideCount = slider.querySelectorAll('.swiper-slide').length;
                const prevBtn = wrapper ? wrapper.querySelector('.bn-slider-case-study__btn--prev') : null;
                const nextBtn = wrapper ? wrapper.querySelector('.bn-slider-case-study__btn--next') : null;

                if (slideCount <= 3) {
                    if (wrapper) wrapper.classList.add('has-few-slides');
                }

                const sliderConfig = {
                    observer: true,
                    observeSlideChildren: true,
                    loop: true,
                    loopedSlides: slideCount,
                    slidesPerView: 'auto',
                    spaceBetween: 20,
                    centeredSlides: true,
                    grabCursor: true,
                    navigation: {
                        nextEl: nextBtn,
                        prevEl: prevBtn,
                    },
                    on: {
                        init: function () {
                            updateNavState(this);
                        },
                        afterInit: function () {
                            slider.classList.add('is-ready');
                        },
                        slideChange: function () {
                            updateNavState(this);
                        },
                    },
                };

                function updateNavState(swiper) {
                    if (!wrapper) return;
                    const prevBtn = wrapper.querySelector('.bn-slider-case-study__btn--prev');
                    const nextBtn = wrapper.querySelector('.bn-slider-case-study__btn--next');
                    if (!swiper.params.loop) {
                        if (prevBtn) prevBtn.classList.toggle('swiper-button-disabled', swiper.isBeginning);
                        if (nextBtn) nextBtn.classList.toggle('swiper-button-disabled', swiper.isEnd);
                    }
                }

                let currentSlider = new Swiper(slider, sliderConfig);
                currentSlider.on('observerUpdate', () => {
                    currentSlider.destroy(currentSlider, true);
                    currentSlider = new Swiper(slider, sliderConfig);
                });
            }
        });
    }
};

document.addEventListener('DOMContentLoaded', function () {
    if (
        !document.body.classList.contains('block-editor-page') &&
        !document.body.classList.contains('block-editor-iframe__body')
    ) {
        sliderCaseStudyInit();
    } else if (window.acf) {
        window.acf.addAction('render_block_preview/type=bn/slider-case-study', sliderCaseStudyInit);
    }
});

